<div class="upi-wrapper" [class]="paymentUtilService.utmProceedClicked ? 'bg-white' : ''">
  <!-- Qr Code and UPI Icons -->
  <div class="qr-warpper" *ngIf="!isMobile">
    <div class="heading">Scan the QR code from the app and make payment</div>
    <div class="upi-qr">
      <img loading="lazy" [hidden]="!qrURL" [src]="'data:image/png;base64,'+qrURL" alt="qr code">
      <div *ngIf="!qrURL" class="linear-background"></div>
    </div>
    <div class="cards">
      <div class="card-section text-center upi-links">
        <div *ngFor="let key of getObjectKeys(option?.TOPUPI)" class="all-bank submit-payment mt-1">
          <span [ngClass]="key.toUpperCase()" matRipple data-bg="../assets/images/payment-modes.png?w=auto"></span>
          <span class="b-name">{{option?.TOPUPI[key]}}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Clickable UPI Icons for mobile -->
  <div *ngIf="isMobile && !vars.disableUpi" class="cards">
    <div class="heading">
      <h2>SELECT A UPI APP</h2>
    </div>
    <div class="card-section text-center upi-links">
      <div *ngFor="let key of getObjectKeys(option?.UPI)" [hidden]="key.match('DESKTOPQR|VPA') || (utilService.getMobileOperatingSystem() === 'iOS' && !iosSupportedIntent.includes(key))" (click)="vars.upiTimer?$event.stopPropagation():submitOrderMobile('UPI', key)" [style.opacity]="vars.upiTimer?'0.5':'1'" class="all-bank submit-payment mt-1 upi-icons">
        <span [ngClass]="key.toUpperCase()" matRipple data-bg="../assets/images/payment-modes.png"></span>
        <span class="b-name">{{option?.UPI[key]}}</span>
      </div>
    </div>
  </div>

  <!-- upi-cashback section -->
  <div class="cashback-section" *ngIf="upiOffers?.length > 0 && vars?.fundraiser?.cause?.parent_cause_id == 20 && vars?.pageName === 'campaign'">
    <div class="cashback-strip" *ngFor="let offer of upiOffers">
      <img loading="lazy" *ngIf="offer?.image" [attr.data-src]="offer?.image" alt="upi_cashback" />
      <img loading="lazy" *ngIf="!offer?.image" src="../assets/images/payment/paytm_cashback.png" alt="upi_cashback" />
      <span class="title" [innerHTML]="offer?.title"></span>
    </div>
  </div>
  <!-- upi-cashback section -->

  <div *ngIf="!vars.disableUpi" class="or">
    <div class="or-line"></div>
    <span class="or-label">OR</span>
    <div class="or-line"></div>
  </div>

  <!-- VPA Payment form and button -->
  <app-upi-input *ngIf="vars.isAgent" [recommendedVpa]="recommendedVpa" [cartDetails]="cartDetails" [isOrderLoading]="isOrderLoading" [disableAll]="vars.upiTimer ? true : false" (onSubmit)="upiInputSubmit($event)"/>
  <form *ngIf="!vars.isAgent" [formGroup]="upiForm" class="upi-form" (ngSubmit)="submit()">
    <mat-form-field class="upi-input" [appearance]="isMobile?'standard':'fill'">
      <mat-label>Enter UPI Address (VPA)</mat-label>
      <input matInput formControlName="upiInput" placeholder="E.g. yourname@icici" [disabled]="vars.upiTimer" (focusout)="onVpaFocusOut()">
      <mat-error *ngIf="upiInput.hasError('pattern') && upiInput.touched">Invalid UPI ID</mat-error>
      <mat-error *ngIf="upiInput.hasError('required') && upiInput.touched">This field is required</mat-error>
    </mat-form-field>
    <app-donate-btn label="Contribute" [btnClass]="'submit-payment'" [amount]="cartDetails?.donated_amount" [disabled]="vars.upiTimer" [isOrderLoading]="isOrderLoading || vars.isOrderLoading">
    </app-donate-btn>
  </form>
  <div *ngIf="paymentUtilService.utmProceedClicked">
    <app-utm-wallet-hundred type="payment" [donation]="cartDetails?.donated_amount"></app-utm-wallet-hundred>
  </div>
  <div *ngIf="vars.upiTimer" class="upi-process" [class.mt-2]="vars.isAgent">
    <span>Open your UPI app on your phone to approve the payment request from Ketto.</span>
    <span class="timer"> ({{countdown}})</span>
    <button class="cancel-btn" type="button" (click)="cancelPayment()" mat-button>Cancel Payment</button>
  </div>
</div>
